import React from 'react'
import { SvgIconProps } from './Home'

const SvgLocationIcon = ({ fill, width, height }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width ?? "12"}
    height={height ?? "15"}
    fill="none"
    viewBox={`0 0 ${width ?? '12'} ${height ?? '15'}`}
  >
    <path
      fill={fill ?? "#353535"}
      d="M12.75 2.118C11.357.74 9.536 0 7.5 0 3.321 0 0 3.282 0 7.412c0 1.482.429 2.965 1.393 4.235l4.393 5.506c.428.53 1.071.847 1.714.847s1.286-.318 1.714-.847l4.393-5.506C14.571 10.377 15 8.894 15 7.412c0-2.012-.75-3.812-2.25-5.294zm.429 5.294c0 1.164-.322 2.33-1.072 3.282l-4.393 5.4c-.107.106-.214.106-.321.106-.107 0-.214 0-.322-.106l-4.285-5.506a5.555 5.555 0 01-.965-3.176C1.821 4.342 4.393 1.8 7.5 1.8c1.5 0 2.893.635 3.964 1.588 1.179 1.06 1.715 2.541 1.715 4.024z"
    ></path>
    <path
      fill={fill ?? "#353535"}
      d="M7.5 4.023c-1.929 0-3.429 1.589-3.429 3.389 0 1.8 1.5 3.388 3.429 3.388 1.928 0 3.428-1.482 3.428-3.388S9.321 4.023 7.5 4.023zm1.607 3.389C9.107 8.259 8.357 9 7.5 9s-1.607-.741-1.607-1.588c0-.847.75-1.589 1.607-1.589s1.607.742 1.607 1.589z"
    ></path>
  </svg>
)





export default SvgLocationIcon